import React, { useCallback } from 'react'
import { IntEditorFunc } from '@/components/report-tables/editors/fIntEditor'
import { areEditorPropsEqual } from '@/components/report-tables/editors/fInputEditor'

const IntPercentageEditorFunc = React.memo(function IntPercentageEditor (props) {
  const getPersistenceValue = useCallback((value) => {
    const float = parseFloat(value)
    return `${!isNaN(float) ? (float / 100).toFixed(2) : ''}`
  }, [])

  const getValue = useCallback((rawValue, char) => {
    const float = parseFloat(rawValue)
    const value = `${!isNaN(float) ? parseFloat((float * 100).toFixed(0)) : ''}`
    return { value: value + char, start: value.length + 1, end: value.length + 1, persistTransform: getPersistenceValue }
  }, [getPersistenceValue])

  return <IntEditorFunc getValue={getValue} getPersistenceValue={getPersistenceValue} {...props} />
}, areEditorPropsEqual)

export { IntPercentageEditorFunc }



// WEBPACK FOOTER //
// ./src/components/report-tables/editors/fIntPercentageEditor.js